/**
 * Auth Composable
 *
 * Provides authentication functionality using the auth store
 */
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores';

export function useAuth() {
  const authStore = useAuthStore();
  const router = useRouter();

  const isAuthenticated = computed(() => authStore.isAuthenticated);
  const user = computed(() => authStore.user);
  const isLoading = computed(() => authStore.isLoading);

  async function logout() {
    authStore.clearAuth();
    await router.push('/login');
  }

  return {
    isAuthenticated,
    user,
    isLoading,
    logout,
  };
}
